module.exports = __webpack_public_path__ + "static/media/ic_delete_hover.65381059.svg";